<div>
  <!-- Header -->
  <div class="d-flex align-items-center justify-content-between mb-2">
    <p class="heading m-0">Brand Scheduler Report</p>
    <button
      type="button"
      class="btn btn-sm btn-outline-primary"
      [disabled]="downloadLoading"
      (click)="downloadReport()"
    >
      {{ downloadLoading ? 'Downloading...' : 'Download XLS' }}
    </button>
  </div>

  <div class="widget-subtitle mb-2">
    Filter by brand and date range to preview and download scheduler execution report.
  </div>

  <!-- Filter Grid -->
  <div class="row no-gutters mb-2">
    <div class="col-md-3 pr-2 mb-2">
      <label class="filter-label">Brand</label>
      <select class="form-control form-control-sm" [(ngModel)]="selectedBrandName">
        <option value="" disabled>Select brand</option>
        <option *ngFor="let brand of brandList" [value]="brand.brandName">
          {{ brand.brandName }}
        </option>
      </select>
    </div>

    <div class="col-md-3 pr-2 mb-2">
      <label class="filter-label">From</label>
      <input type="date" class="form-control form-control-sm" [(ngModel)]="fromDate" />
    </div>

    <div class="col-md-3 pr-2 mb-2">
      <label class="filter-label">To</label>
      <input type="date" class="form-control form-control-sm" [(ngModel)]="toDate" />
    </div>

    <div class="col-md-3 pr-2 mb-2">
      <label class="filter-label">Platform (optional)</label>
      <select class="form-control form-control-sm" [(ngModel)]="platform">
        <option value="">All</option>
        <option *ngFor="let platformOption of platformList" [value]="platformOption.platformName">
          {{ platformOption.platformName }}
        </option>
      </select>
    </div>

    <!-- Executed By (Width: 5 columns) -->
    <div class="col-md-5 pr-2 mb-2">
      <label class="filter-label">Executed By</label>
      <div class="user-filter-dropdown" [class.open]="showUserDropdown">
        <button
          type="button"
          class="form-control form-control-sm text-left user-filter-toggle"
          (click)="toggleUserDropdown()"
        >
          <span>{{ userFilterLabel }}</span>
          <span class="user-filter-caret">&#9662;</span>
        </button>

        <div class="user-filter-menu" *ngIf="showUserDropdown">
          <div class="user-filter-actions" *ngIf="userOptions.length > 0">
            <button type="button" class="btn btn-link btn-sm p-0 mr-2" (click)="selectAllUsers()">
              Select All
            </button>
            <button type="button" class="btn btn-link btn-sm p-0" (click)="clearUserSelection()">
              Clear
            </button>
          </div>

          <div class="user-filter-empty" *ngIf="userOptions.length === 0">
            No users available
          </div>

          <div class="user-filter-list" *ngIf="userOptions.length > 0">
            <label class="user-filter-option" *ngFor="let user of userOptions">
              <input
                type="checkbox"
                [checked]="isUserSelected(user)"
                (change)="onUserSelectionChange(user, $event.target.checked)"
              />
              <span>{{ user }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Build Name (Width: 5 columns - Equal to Executed By) -->
    <div class="col-md-5 pr-2 mb-2">
      <label class="filter-label">Build Name (optional)</label>
      <input
        type="text"
        class="form-control form-control-sm"
        placeholder="Enter build name"
        [(ngModel)]="buildName"
      />
    </div>

    <!-- View Button (Width: 2 columns) -->
    <div class="col-md-2 d-flex align-items-end mb-2">
      <button type="button" class="btn btn-sm btn-primary w-100" [disabled]="loading" (click)="fetchReport()">
        {{ loading ? 'Loading...' : 'View' }}
      </button>
    </div>
  </div>

  <div *ngIf="errorMessage" class="error-msg mb-2">{{ errorMessage }}</div>

  <!-- Table -->
  <div class="table-responsive" *ngIf="!loading">
    <table class="table table-sm table-striped table-bordered m-0" *ngIf="reportRows.length > 0">
      <thead>
        <tr>
          <th>Date</th>
          <th>Job Name</th>
          <th>Owner</th>
          <th>History Id</th>
          <th>Platform</th>
          <th>Pass</th>
          <th>Fail</th>
          <th>Skip</th>
          <th>Total</th>
          <th>Build</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of reportRows">
          <td>{{ row.executionDate }}</td>
          <td>{{ row.jobName }}</td>
          <td>{{ row.createdBy }}</td>
          <td>{{ row.exeHistoryId }}</td>
          <td>{{ row.platformName }}</td>
          <td class="pass-text">{{ row.schedulerPassCount }}</td>
          <td class="fail-text">{{ row.schedulerFailCount }}</td>
          <td class="skip-text">{{ row.schedulerSkipCount }}</td>
          <td>{{ row.schedulerTotalCases }}</td>
          <td>{{ row.appVersion }}</td>
        </tr>
      </tbody>
    </table>

    <div class="no-record" *ngIf="reportRows.length === 0 && !errorMessage">
      No report rows found for selected filter.
    </div>
  </div>
</div>